import type { IUploadQueue } from "@/models";
import { defined } from "@/utils/variable-evaluation";
import { createReducer } from "@reduxjs/toolkit";
import { IBackgroundUploaderActions } from "./background-uploader-actions";

export interface IBackgroundUploaderModel {
  uploadQueues: Record<string, IUploadQueue>;
}

const INITIAL_STATE: IBackgroundUploaderModel = {
  uploadQueues: {},
};

/** Reducer */
export const backgroundUploaderReducer = createReducer(
  INITIAL_STATE,
  (builder) => {
    builder
      .addCase(
        IBackgroundUploaderActions.addUploadQueue,
        (state, action): IBackgroundUploaderModel => {
          const uploadQueue: IUploadQueue = action.payload;
          if (!defined(state.uploadQueues[uploadQueue.id])) {
            return {
              ...state,
              uploadQueues: {
                ...state.uploadQueues,
                [uploadQueue.id]: uploadQueue,
              },
            };
          }
          console.warn(
            "backgroundUploaderReducer ADD__UPLOAD_QUEUE skipped because queue with same id already exists",
            uploadQueue
          );
          return state;
        }
      )
      .addCase(
        IBackgroundUploaderActions.updateUploadQueue,
        (state, action): IBackgroundUploaderModel => {
          const uploadQueue: IUploadQueue = action.payload;
          return {
            ...state,
            uploadQueues: {
              ...state.uploadQueues,
              [uploadQueue.id]: uploadQueue,
            },
          };
        }
      )
      .addCase(
        IBackgroundUploaderActions.removeUploadQueue,
        (state, action): IBackgroundUploaderModel => {
          const id: string = action.payload;
          if (defined(state.uploadQueues[id])) {
            const newUploadQueues = { ...state.uploadQueues };
            delete newUploadQueues[id];
            return {
              ...state,
              uploadQueues: newUploadQueues,
            };
          }
          return state;
        }
      );
  }
);
